/** @jsxImportSource @emotion/react */
import { useParams } from "react-router";
import { Divider } from "../../../../components/Divider";
import { RouteFullScreenModal } from "../../../../components/RouteFullScreenModal";
import { MutateBusinessLineForm } from "../components/MutateBusinessLineForm";
import { useGetAdyenAccountHolderBusinessLine } from "../../service/adyen-account-holders-api";
import { SpinnerBlock } from "../../../common/Spinner";

export const EditBusinessLinePage = () => {
  const { businessLineId, id } = useParams();
  const {
    data: businessLine,
    isLoading,
  } = useGetAdyenAccountHolderBusinessLine(id, businessLineId);

  return (
    <RouteFullScreenModal title="Edit business line">
      <Divider />
      {isLoading ? (
        <SpinnerBlock />
      ) : (
        <MutateBusinessLineForm businessLine={businessLine} />
      )}
    </RouteFullScreenModal>
  );
};
